// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconLogoWineDirect = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M1 5.7v12.614h2.614q1.92 0 2.966-.35 1.12-.353 2.14-1.25 1.738-1.536 1.991-3.88h10.414v5.48H23V5.765h-1.875v5.337h-10.42Q10.44 8.82 8.801 7.326a5.6 5.6 0 00-2.148-1.25Q5.55 5.7 3.647 5.7zm2.761 10.825h-.857V7.49h.857q2.436 0 3.685 1.152 1.389 1.29 1.389 3.366 0 2.059-1.405 3.342-.687.62-1.536.907-.85.27-2.133.27"
    />
  );
export default SvgIconLogoWineDirect;
